export default {
      id: "propeller-usage",
      viewBox: "0 0 46 55",
      url: __webpack_public_path__ + "img/icons.507a1d9d.svg#propeller",
      toString: function () {
        return this.url;
      }
    }